module.exports = __webpack_public_path__ + "media/images/no-rec-2a21a976ff56f7cc04029238519592dd.png";